import { mockBuilder } from '../utils/builderHelper.es.js';
import { Permissions } from './Permissions.es.js';

/** @module Mocks */ /** typedoc */
/**
 * Create a Permission Object
 * @returns {Permissions}
 */
function aPermissions() {
    return mockBuilder(new Permissions()).withWrite(true);
}

export { aPermissions };
